import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBusinessGreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Capa_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 800 800",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #05cc76;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M503.52,270.95h237.26c9.32,0,21.71,14.44,21.22,23.94v443.31c-1.38,13.35-11.24,23-24.66,23.97H62.65c-13.43-.98-23.28-10.63-24.66-23.97V166.35c.69-9.54,5.68-17.58,14.15-21.98L473.47,38.38c11.64-3.48,30.04,10.01,30.04,21.71v210.86ZM451.41,710.04V97.25L90.13,187.57v522.47h102.83v-132.35c0-9.63,13.48-22.53,23.36-22.49,34.89,1.68,72.34-2.53,106.94-.12,11.54.8,25.33,10.94,25.33,23.31v131.66h102.83ZM709.86,323.06h-206.35v386.99h206.35v-386.99ZM296.47,607.22h-51.41v102.83h51.41v-102.83Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M190.72,451.78l159.52-.11c31.09,3.95,32.26,46.45,1.4,51.95h-161.73c-30.46-5.15-29.88-47.5.81-51.84Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M320.65,348.27c11.32-1.21,49.84-1.65,59.92.81,27.08,6.62,25.32,46.91-2.53,51.01-18.83-1.08-39.73,1.7-58.31.1-30.09-2.59-31.74-48.42.92-51.93Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M165.72,348.27c10.89-1.17,50.42-1.64,59.93.8,27.15,6.99,25.02,46.69-2.54,51.02-18.83-1.08-39.73,1.7-58.31.1-30.41-2.62-31.7-48.43.92-51.93Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M162.2,245.41c19.36,1.03,41.24-1.94,60.31-.2,28.79,2.64,30.09,46.46,1.3,51.38-19.28-1.15-40.69,1.73-59.72.08-28.59-2.48-30.38-45.84-1.89-51.27Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M317.14,245.41c19.36,1.03,41.24-1.94,60.31-.2,28.97,2.65,30.21,46.58,1.28,51.37-19.19-1.18-40.8,1.84-59.7.11-28.45-2.61-30.24-45.73-1.89-51.28Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M576.99,426.06c18.52.88,39.24-1.79,57.51-.2,31.72,2.75,31.77,48.79.58,52.05-13.61,1.42-41.74,1.28-55.52.11-31.29-2.66-33.09-46.27-2.57-51.95Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M576.99,555.29c18.52.88,39.24-1.79,57.51-.2,31.72,2.75,31.77,48.79.58,52.05-13.61,1.42-41.74,1.28-55.52.11-31.29-2.66-33.09-46.27-2.57-51.95Z"
		})
	]
});
export default SvgBusinessGreen;
